import { render, staticRenderFns } from "./CollectionAddStaff.vue?vue&type=template&id=5c4f3b62&"
import script from "./CollectionAddStaff.vue?vue&type=script&lang=js&"
export * from "./CollectionAddStaff.vue?vue&type=script&lang=js&"
import style0 from "./CollectionAddStaff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports